import axios from "axios";
import authHeader from "./auth/auth-header";
import { interceptor } from "./interceptor";
import { BASE_URL } from "../Constatns";

const API_URL = BASE_URL + "";

class FuelService {
  async getTaskStats(employeeId) {
    interceptor();
    return axios.get(API_URL + "Task/TaskStats/" + employeeId + "/", {
      headers: authHeader(),
    });
  }

  async getLatestFuelPrice() {
    interceptor();
    return axios.get(API_URL + "FuelPrice/GetLatest", {
      headers: authHeader(),
    });
  }

  async saveFuelPrice(body) {
    interceptor();
    return axios.post(API_URL + "FuelPrice/Save", body, {
      headers: authHeader(),
    });
  }

  async getLatestVehicleAverage() {
    interceptor();
    return axios.get(API_URL + "VehicleAverage/GetLatest", {
      headers: authHeader(),
    });
  }

  async saveVehicleAverage(body) {
    interceptor();
    return axios.post(API_URL + "VehicleAverage/Save", body, {
      headers: authHeader(),
    });
  }

  async getLatestOutOfBoundRadius() {
    interceptor();
    return axios.get(API_URL + "Settings/OutOfBoundRadius", {
      headers: authHeader(),
    });
  }

  async saveOutOfBoundRadius(body) {
    interceptor();
    return axios.post(API_URL + "Settings/UpdateOutOfBoundRadius", body, {
      headers: authHeader(),
    });
  }
}

export default new FuelService();
